import { FC } from 'react'
import { Icon } from '@chakra-ui/react'

import { uniqueId } from '@/services'

export const Mp3: FC = () => {
  const id = `clip${uniqueId()}`
  return (
    <Icon
      width="70px"
      height="70px"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3171_3724)">
        <path
          d="M43.75 2.1875V19.6875H61.25"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
        <path
          d="M61.25 28.4375V19.6875L43.75 2.1875H8.75V28.4375"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.75 59.0625V67.8125H61.25V59.0625"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M22.75 50.3125L20.125 41.3438C20.3437 42.875 20.3438 43.9688 20.3438 44.8438V50.3125H17.2812V37.8438H21.875L24.5 46.8125L27.125 37.8438H31.7188V50.3125H28.4375V44.8438C28.4375 44.625 28.4375 44.1875 28.4375 43.9688C28.4375 43.75 28.4375 42.875 28.6563 41.3438L25.8125 50.3125H22.75Z"
          fill="white"
        />
        <path
          d="M43.3125 41.7813C43.3125 43.0938 42.875 44.1875 42 45.0625C41.125 45.9375 40.0313 46.1563 38.5 46.1563H37.625V50.3125H34.3438V37.8438H38.7188C40.25 37.8438 41.5625 38.2812 42.2187 38.9375C42.875 39.5938 43.3125 40.4688 43.3125 41.7813ZM37.625 43.3125H38.2813C38.7188 43.3125 39.1563 43.0938 39.5938 42.875C40.0313 42.6563 40.0312 42.2188 40.0312 41.7813C40.0312 40.9063 39.5938 40.4688 38.7188 40.4688H37.8437V43.3125H37.625Z"
          fill="white"
        />
        <path
          d="M52.9375 40.4688C52.9375 41.3438 52.7188 42 52.2813 42.4375C51.8438 42.875 51.1875 43.5312 50.3125 43.75C52.5 43.9688 53.375 45.0625 53.375 46.8125C53.375 47.9062 52.9375 48.7813 52.0625 49.6563C51.1875 50.5313 49.875 50.75 48.125 50.75C47.4688 50.75 46.8125 50.75 46.1563 50.5313C45.5 50.3125 45.0625 50.3125 44.4062 50.0937V47.25C44.8438 47.4688 45.5 47.6875 46.1563 47.9062C46.8125 48.125 47.25 48.125 47.6875 48.125C48.3438 48.125 49 48.125 49.2188 47.9062C49.4375 47.6875 49.6563 47.4688 49.6563 47.0312C49.6563 46.5938 49.6563 46.375 49.4375 46.1563C49.2188 45.9375 49 45.9375 48.5625 45.7187C48.125 45.5 47.6875 45.5 47.0313 45.5H46.1563V42.875H47.0313C48.7813 42.875 49.6563 42.4375 49.6563 41.5625C49.6563 41.125 49.4375 40.9063 49.2188 40.9063C49 40.9063 48.5625 40.6875 48.125 40.6875C47.25 40.6875 46.5938 40.9062 45.7188 41.5625L44.4062 39.375C45.0625 38.9375 45.7188 38.5 46.375 38.5C47.0313 38.5 47.9062 38.2812 48.7812 38.2812C50.0938 38.2812 51.1875 38.5 51.8438 39.1562C52.5 39.8125 52.9375 39.5938 52.9375 40.4688Z"
          fill="white"
        />
        <path
          d="M67.8125 28.4375H2.1875V59.0625H67.8125V28.4375Z"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="70px" height="70px" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
